import Navbar from './components/Navbar';
import Hero from './components/Hero';

import Partners from './components/Partners';
import WhatWeDo from './components/WhatWeDo';
import VideoAds from './components/VideoAds';
import Testimonial from './components/Testimonial';
import GetStarted from './components/GetStarted';
import Features from './components/Features';
import TheNumbers from './components/TheNumbers';
import Footer from './components/Footer';
import ContactForm from './components/ContactForm';
import { ContactFormProvider, useContactForm } from './context/ContactFormContext';
import backgroundImage from './components/assets/Home/bg.png';
import './App.css';

function AppContent() {
  const { isOpen, closeForm } = useContactForm();

  return (
    <div 
      className="App min-h-screen bg-surface relative overflow-x-hidden w-full max-w-[100vw]"
      style={{
        backgroundImage: `url(${backgroundImage})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        backgroundAttachment: 'fixed'
      }}
    >
      {/* Light overlay for cohesive bright theme */}
      <div className="fixed inset-0 bg-surface/85 z-0 pointer-events-none"></div>
      
      <div className="relative z-10">
        <Navbar />
        <div id="hero">
          <Hero />
        </div>
        <div id="whatwedo">
          <WhatWeDo />
        </div>
        <div id="features">
          <Features />
        </div>
        <div id="videoads">
          <VideoAds />
        </div>
        <div id="testimonial">
          <Testimonial />
        </div>
        <div id="thenumbers">
          <TheNumbers />
        </div>
        <div id="getstarted">
          <GetStarted />
        </div>
        <div id="partners">
          <Partners />
        </div>
        <Footer />
      </div>
      
      {/* Contact Form Modal */}
      <ContactForm isOpen={isOpen} onClose={closeForm} />
    </div>
  );
}

function App() {
  return (
    <ContactFormProvider>
      <AppContent />
    </ContactFormProvider>
  );
}

export default App;
